import { render, staticRenderFns } from "./StorefrontShippedCount.vue?vue&type=template&id=0cc163ce"
import script from "./StorefrontShippedCount.vue?vue&type=script&lang=js"
export * from "./StorefrontShippedCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports